module.exports = __webpack_public_path__ + "static/media/Subscriber-Exclusive-Tablet-Banner1476x114px.031cd318.jpg";